const TrainingSessionsStats = ({
  totalSessions,
  parentSessionsCount,
  splitSessionsCount,
  onExpandAll,
  onCollapseAll,
}) => {
  return (
    <div className="hidden border-b border-gray-200 bg-gray-50 px-6 py-4 md:block">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
        <div className="flex items-center gap-6">
          <div className="text-sm text-gray-600">
            <span className="font-medium">{totalSessions}</span> total sessions
          </div>
          <div className="text-sm text-gray-600">
            <span className="font-medium">{parentSessionsCount}</span> parent sessions
          </div>
          <div className="text-sm text-gray-600">
            <span className="font-medium">{splitSessionsCount}</span> split sessions
          </div>
        </div>
        <div className="flex items-center gap-2">
          <button
            onClick={onExpandAll}
            className="rounded-md bg-blue-100 px-3 py-1.5 text-xs text-blue-700 transition-colors hover:bg-blue-200"
          >
            Expand All
          </button>
          <button
            onClick={onCollapseAll}
            className="rounded-md bg-gray-100 px-3 py-1.5 text-xs text-gray-700 transition-colors hover:bg-gray-200"
          >
            Collapse All
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrainingSessionsStats;
